var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  应急总结报告，相关导出文档，包含接警单、事件会商单、应急处置单，或者通过合打的方式打印，内容见sheet《接警单》《事件会商单》《应急处置单》《合打单》\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }